/**
 * Where a [start, end] span sits inside a visible window, as percentages of
 * the track: `left` is the position, `width` is the span — never the end
 * position, which drew every cut twice as wide as it was and made the drawn
 * edge miss the real one.
 */
export function spanBox(
  start: number,
  end: number,
  viewStart: number,
  viewEnd: number,
): { left: number; width: number } {
  const visible = Math.max(1e-6, viewEnd - viewStart);
  const units = (time: number): number =>
    Math.max(0, Math.min(100, ((time - viewStart) / visible) * 100));
  const left = units(Math.min(start, end));
  const right = units(Math.max(start, end));
  return { left, width: Math.max(0, right - left) };
}
